import React, { useState } from "react";
import Cookies from "js-cookie";
import * as $ from "jquery";

function NewFeaturePopup(props) {
  const [featurePopup, setFeaturePopup] = useState(Cookies.get("examFinding"));

  const remindMeLater = (name, value, expire_days, hidePopUp) => {
    Cookies.set(`${name}`, `${value}`, { expires: expire_days });
    $(`${hidePopUp}`).hide();

    if (name == 'examFinding') {
      setFeaturePopup(Cookies.get("examFinding"));
    }
  };

  return (
    <>
      {featurePopup !== "examFindingUpdate" && (
        <div className="support-pop-up-align pop-up-align bg-white shadow-lg m-4 border-radius-10">
          <div className="bg-primary py-3 top-primary-bar text-right d-flex justify-content-between align-items-center">
            <h6 className="px-5 text-white">🎉 New Feature!</h6>
            <button className="btn p-0" onClick={() => remindMeLater('examFinding', 'examFindingUpdate', 90, '.support-pop-up-align')}>
              <i className="las la-times text-white font-size-12 mr-3"></i>
            </button>
          </div>
          <div className="p-5">
            <h6>Exam Autocoding + Associated Plan Is Live!</h6>
            <p className="my-3">
              👉 <a className="btn-link" href="https://www.manula.com/manuals/itrust/itrust-optometry-cloud-ehr/2/en/topic/auto-fill-exam-findings-associated-diagnosis-and-default-plans" target="_blank">Manual topic</a>
            </p>
            <p>
              📺 <a className="btn-link" href="https://www.youtube.com/watch?v=0WcFWuzfSQM" target="_blank">Watch the YouTube demo</a>
            </p>
          </div>
        </div>
      )}
    </>
  );
}

export default NewFeaturePopup;